// Generated by CoffeeScript 2.7.0
var TimePickerMixin;

export default TimePickerMixin = {
  props: {
    initValue: {
      type: Date,
      default: function() {
        return new Date();
      }
    }
  },
  data: function() {
    if (this.initValue == null) {
      this.initValue = new Date();
    }
    return {
      time: {
        hour: this.initValue.getHours(),
        minute: this.initValue.getMinutes()
      }
    };
  },
  watch: {
    hour: function() {
      return this.onValueChanged();
    },
    minute: function() {
      return this.onValueChanged();
    }
  },
  computed: {
    minute: {
      get: function() {
        return this.time.minute;
      },
      set: function(new_value) {
        return this.time.minute = new_value;
      }
    },
    hour: {
      get: function() {
        return this.time.hour;
      },
      set: function(new_value) {
        return this.time.hour = new_value;
      }
    }
  },
  methods: {
    onValueChanged: function() {
      return this.$emit('valueChanged', Date.parseFromString(`${this.hour.zeroFill()}:${this.minute.zeroFill()}`));
    }
  }
};
